"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionStatus = exports.HttpMethod = exports.Processor = void 0;
var Processor;
(function (Processor) {
    Processor["VANTIV"] = "Vantiv";
    Processor["VANTIV_CANADA"] = "VantivCanada";
})(Processor || (exports.Processor = Processor = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["DELETE"] = "DELETE";
})(HttpMethod || (exports.HttpMethod = HttpMethod = {}));
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["OPEN"] = "Open";
    ConnectionStatus["CLOSED"] = "Closed";
})(ConnectionStatus || (exports.ConnectionStatus = ConnectionStatus = {}));
//# sourceMappingURL=enums.js.map